$(function() {
	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = timestamp => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min(
				(timestamp - startTimestamp) / duration,
				1
			);
			if (obj)
				obj.innerText = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	let obj = document.getElementById('pl_park_c22');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c2');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c3');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c4');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c5');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c6');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c7');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c8');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c9');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c10');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c11');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);

	obj = document.getElementById('pl_park_c12');
	if (obj) animateValue(obj, 0, obj.dataset.ncount, 4000);
});

// contador se inicia al ser visualizado inicia
$(function() {
	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = timestamp => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min(
				(timestamp - startTimestamp) / duration,
				1
			);
			if (obj)
				obj.innerText = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	// Crear un observador con una función de callback
	const contadorObserver = new IntersectionObserver(function(
		entries,
		observer
	) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				// Obtener el objeto del contador y los valores de inicio y fin desde los atributos de datos
				const obj = entry.target;
				const start = 0;
				const end = parseInt(obj.dataset.ncount);
				const duration = 4000;

				// Iniciar el contador
				animateValue(obj, start, end, duration);

				// Dejar de observar el elemento
				observer.unobserve(obj);
			}
		});
	});

	// Obtener todos los elementos del contador
	const contadorElementos = document.querySelectorAll('[data-ncount]');

	// Observar cada elemento del contador
	contadorElementos.forEach(function(obj) {
		contadorObserver.observe(obj);
	});
});

// contador se inicia al ser visualizado termina
